import React, { Component, Fragment } from "react";
import "react-toastify/dist/ReactToastify.css";

export class SideBarComponent extends Component {
  _isMounted = false;
  static displayName = SideBarComponent.name;
  nav = document.getElementById("access_nav");
  constructor(props) {
    super(props);
    this.state = {
      pageName: "Dashboard",
      menuHtml: null,
      userMenu: [],
      accountProfileImage: "../assets/img/defaultlogo.png",
      fileGuid: "00000000-0000-0000-0000-000000000000",
      fileUrl: "../assets/img/defaultlogo.png",
      userTypeId: Number(sessionStorage.getItem("session_userTypeId")),
    };
  }
  componentDidMount() {
    document.querySelector("#lblPageTitle").innerHTML =
      sessionStorage.getItem("session_PageName") === null
        ? "Dashboard"
        : sessionStorage.getItem("session_PageName");
    this._isMounted = true;
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  handleLogout = async (e) => {
    e.preventDefault();
    sessionStorage.clear();
    window.location.href = "/";
  };
  getAccountLogo = async () => {
    try {
      // var fileGuid = sessionStorage.getItem("session_fileGuid");
      // var accountLogo = sessionStorage.getItem("session_accountLogoName");
      // var logoExtenstion = sessionStorage.getItem("session_accountLogoExt");
      // if (fileGuid !== "00000000-0000-0000-0000-000000000000") {
      //     const requestParams = getRequestParams('GET');
      //     const response = await fetch(process.env.REACT_APP_API_BASE_URL + 'File/download/' + fileGuid, requestParams);
      //     const data = await response.json();
      //     this.setState({
      //         accountProfileImage: 'data:' + data.payload.mimeType + ';base64,' + data.payload.fileContent,
      //         fileUrl: data.payload.fileUrl });
      // }
      // if (accountLogo != "") {
      //     this.setState({
      //         fileUrl: "../assets/img/accountLogo/" + accountLogo + logoExtenstion
      //     });
      // }
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getAccountLogo function",
        err,
      );
      this.setState({ loadPanelVisible: false });
    }
  };
  // getUserRoleFeatureList = async () => {
  //   try {
  //     let userId = sessionStorage.getItem("session_userId");
  //     let planId = sessionStorage.getItem("session_planId");
  //     const requestParams = getRequestParams("GET");
  //     this.setState({
  //       loadPanelVisible: true,
  //     });

  //     var sessionmenu = JSON.parse(sessionStorage.getItem("session_menu"));
  //     if (sessionmenu === null) {
  //       const response = await fetch(
  //         process.env.REACT_APP_API_BASE_URL +
  //           "UserPermission/" +
  //           userId +
  //           "/role-feature/" +
  //           parseInt(planId) +
  //           "/" +
  //           Number(FeatureActionType.UTWiz),
  //         requestParams
  //       );
  //       if (response.ok) {
  //         let data = await response.json();
  //         sessionStorage.setItem("session_menu", JSON.stringify(data));
  //         data = JSON.parse(JSON.stringify(data.userRoleFeature));
  //         data = data.filter((el) => el.isActive === true);
  //         let menuHtmlItem = this.getMenuHtml(data);
  //         this.setState({
  //           menuHtml: menuHtmlItem,
  //           userMenu: data,
  //         });
  //       }
  //     } else {
  //       let data = sessionmenu.userRoleFeature;
  //       data = data.filter((el) => el.isActive === true);
  //       let menuHtmlItem = this.getMenuHtml(data);
  //       this.setState({
  //         menuHtml: menuHtmlItem,
  //         userMenu: data,
  //       });
  //     }
  //   } catch (err) {
  //     console.log(
  //       "Error in " + this.displayName + ".getUserRoleFeatureList function",
  //       err
  //     );
  //     this.setState({ loadPanelVisible: false });
  //   }
  // };
  // getMenuHtml(menuFeature) {
  //   let menuHtmlItem = [];
  //   menuFeature = JSON.parse(JSON.stringify(menuFeature));
  //   menuFeature.forEach((menu) => {
  //     if (menu.parentMenuId === 0) {
  //       let childMenu = menuFeature.filter(
  //         (el) => el.parentMenuId === menu.childMenuId
  //       );
  //       if (childMenu.length > 0) {
  //         menuHtmlItem.push(
  //           <li key={menu.childMenuId} className="dropdown">
  //             <a
  //               href={menu.componentPath === "" ? "/" : menu.componentPath}
  //               className="nav-link has-dropdown"
  //               title={menu.menuName}
  //               data-toggle="dropdown"
  //             >
  //               <i className={menu.className}></i>
  //               <span>{menu.menuName}</span>
  //             </a>
  //             <ul key={menu.childMenuId} className="dropdown-menu">
  //               {this.subMenuHtml(menuFeature, menu)}
  //             </ul>
  //           </li>
  //         );
  //       } else {
  //         menuHtmlItem.push(
  //           <NavItem key={menu.childMenuId}>
  //             <NavLink
  //               tag={Link}
  //               to={menu.componentPath}
  //               title={menu.menuName}
  //               onClick={(e) => {
  //                 this.menuClick(e, menu.menuName);
  //               }}
  //             >
  //               <i className={menu.className}></i>
  //               <span>{menu.menuName}</span>
  //             </NavLink>
  //           </NavItem>
  //         );
  //       }
  //     }
  //   });
  //   return menuHtmlItem;
  // }

  // subMenuHtml = (menuFeature, menuList) =>
  //   menuFeature
  //     .filter((el) => el.parentMenuId === menuList.childMenuId)
  //     .map((subchild) =>
  //       menuFeature.filter((el) => el.parentMenuId === subchild.childMenuId)
  //         .length === 0 ? (
  //         <NavItem key={subchild.childMenuId}>
  //           <NavLink
  //             tag={Link}
  //             to={subchild.componentPath}
  //             title={subchild.menuName}
  //             onClick={(e) => {
  //               this.menuClick(e, subchild.menuName);
  //             }}
  //           >
  //             <i className={subchild.className}></i>
  //             <span>{subchild.menuName}</span>
  //           </NavLink>
  //         </NavItem>
  //       ) : null
  //     );

  // menuClick = async (e, currentPageName) => {
  //   document.querySelector("#lblPageTitle").innerHTML = currentPageName;
  //   if (currentPageName === "Fuel (Legacy Site)") {
  //     let accountId = parseInt(sessionStorage.getItem("session_accountId"));
  //     let locationId = parseInt(sessionStorage.getItem("session_locationId"));
  //     let userId = parseInt(sessionStorage.getItem("session_userId"));

  //     const requestParams = getRequestParams("GET");
  //     console.log(process.env.REACT_APP_API_BASE_URL);
  //     const response = await fetch(
  //       process.env.REACT_APP_API_BASE_URL +
  //         "authentication/wialon-authentication/" +
  //         accountId +
  //         "/" +
  //         locationId +
  //         "/" +
  //         userId,
  //       requestParams
  //     );
  //     const data = await response.json();

  //     if (data.payload != null && data.payload != undefined) {
  //       window.open(data.payload, "_blank");
  //     } else {
  //       toast.success("Invalid access", {
  //         position: toast.POSITION.BOTTOM_CENTER,
  //         autoClose: 5000,
  //         style: { width: "310px" },
  //         hideProgressBar: false,
  //         newestOnTop: false,
  //       });
  //     }
  //   } else {
  //     this.setState({
  //       menuName: e.currentTarget.innerText,
  //       pageName: currentPageName,
  //     });
  //     sessionStorage.setItem("session_PageName", currentPageName);
  //   }
  // };

  menuClick = async (e, currentPageName) => {
    try {
      // this.setState((prev) => ({
      //   ...prev,
      //   pageName: currentPageName,
      // }));
      // sessionStorage.setItem("session_PageName", currentPageName);
    } catch (error) {
      console.log(error);
    }
  };
  render() {
    return (
      <Fragment>
        <style>{`
          #sidebar-wrapper {
            background: #ffffff !important;
            border-right: 1px solid #e5e7eb !important;
            box-shadow: 2px 0 8px rgba(0,0,0,0.08) !important;
            display: flex !important;
            flex-direction: column !important;
            height: 100vh !important;
            overflow: hidden !important;
          }
          #sidebar-wrapper .sidebar-brand {
            border-bottom: 1px solid #f0f0f0 !important;
            background: #ffffff !important;
            flex-shrink: 0 !important;
          }
          .sidebar-brand-silverstar-sm {
            background: #ffffff !important;
          }
          #sidebar-wrapper .sidebar-menu {
            flex: 1;
            overflow-x: hidden !important;
            overflow-y: auto !important;
            scrollbar-width: none !important;
            -ms-overflow-style: none !important;
            padding: 0.4rem 0 !important;
          }
          #sidebar-wrapper .sidebar-menu::-webkit-scrollbar {
            display: none !important;
          }
          /* Main menu items — dark text on white background */
          #sidebar-wrapper .nav-link {
            color: #374151 !important;
            border-radius: 8px !important;
            margin: 1px 8px !important;
            padding: 0.35rem 0.8rem !important;
            font-size: 0.82rem !important;
            font-weight: 600 !important;
            transition: background 0.18s ease, color 0.18s ease !important;
            display: flex !important;
            align-items: center !important;
            gap: 0.5rem !important;
            white-space: normal !important;
            overflow: visible !important;
            text-overflow: unset !important;
            word-break: break-word !important;
          }
          #sidebar-wrapper .nav-link span {
            flex: 1 !important;
            min-width: 0 !important;
          }
          #sidebar-wrapper .nav-link:hover,
          #sidebar-wrapper .nav-link:focus {
            background: #fff3ec !important;
            color: #FF6600 !important;
          }
          #sidebar-wrapper .nav-link i {
            width: 18px !important;
            text-align: center !important;
            font-size: 0.88rem !important;
            color: #FF6600 !important;
            opacity: 1 !important;
            flex-shrink: 0 !important;
          }
          #sidebar-wrapper .dropdown-menu {
            background: #2d2d2d !important;
            box-shadow: none !important;
            border: none !important;
            border-left: none !important;
            margin-left: 0 !important;
            padding: 4px 0 !important;
            position: static !important;
            display: none !important;
            width: auto !important;
            min-width: 0 !important;
            border-radius: 0 !important;
          }
          #sidebar-wrapper .dropdown-menu.show,
          #sidebar-wrapper li.show > .dropdown-menu,
          #sidebar-wrapper li.open > .dropdown-menu,
          #sidebar-wrapper li.active > .dropdown-menu {
            display: block !important;
          }
          /* Sub-menu items — white text on dark background */
          #sidebar-wrapper .dropdown-menu .nav-link {
            font-size: 0.79rem !important;
            font-weight: 500 !important;
            color: #ffffff !important;
            padding: 0.38rem 1rem !important;
            border-radius: 0 !important;
            margin: 0 !important;
            white-space: normal !important;
            overflow: visible !important;
            line-height: 1.3 !important;
          }
          #sidebar-wrapper .dropdown-menu .nav-link:hover,
          #sidebar-wrapper .dropdown-menu .nav-link:focus {
            background: #fff3ec !important;
            color: #FF6600 !important;
          }
          #sidebar-wrapper .dropdown-menu .nav-link i {
            color: #FF6600 !important;
          }
          .sidebar-powered-by {
            border-top: 1px solid #f0f0f0;
            padding: 0.6rem 1rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 0.3rem;
            font-size: 0.65rem;
            color: rgb(0 0 0 / 48%) !important;
            font-weight: 500;
            letter-spacing: 0.07em;
            text-transform: uppercase;
            text-align: center;
            transition: color 0.2s;
          }
          .sidebar-powered-by img {
            height: 20px;
            filter: none;
            opacity: 0.55;
            transition: opacity 0.2s;
          }
          .sidebar-powered-by:hover img { opacity: 0.9; }
          .sidebar-powered-by:hover { color: rgba(0,0,0,0.6); }
        `}</style>
        <div className="main-sidebar">
          <aside
            id="sidebar-wrapper"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div className="sidebar-brand">
              <a href="/">
                <img
                  src="../assets/img/logo_akasa_air_inside.png"
                  className="Akasa Air"
                  width="180px"
                />
              </a>
            </div>
            <div className="sidebar-brand-silverstar-sm">
              <a href="/">
                <img
                  src="../assets/img/icon_akasa_air.png"
                  style={{ width: "24px", height: "24px" }}
                />
              </a>
            </div>
            <div className="companyLogoBox sidebar-brand-sm">
              <img src="../assets/img/defaultlogo.png" />
            </div>
            <div className="sidebar-brand sidebar-brand-sm"></div>
            {this.state.userTypeId !== 10 ? (
              <ul className="sidebar-menu">
                <li className="nav-item">
                  <a
                    title="Dashboard"
                    className="nav-link"
                    href="/dashboard"
                    onClick={(e) => {
                      this.menuClick(e, "Dashboard");
                    }}
                  >
                    <i className="fas fa-chalkboard"></i>
                    <span>Dashboard</span>
                  </a>
                </li>
                {/* <li className="nav-item">
                  <a
                    title="Schedule Dashboard"
                    className="nav-link"
                    href="/scheduleDashboard"
                    onClick={(e) => {
                      this.menuClick(e, "Schedule Dashboard");
                    }}
                  >
                    <i className="fas fa-calendar-alt"></i>
                    <span>Schedule Dashboard</span>
                  </a>
                </li> */}
                <li className="nav-item">
                  <a
                    title="Crew Transfers"
                    className="nav-link"
                    href="/dispatch"
                    onClick={(e) => {
                      this.menuClick(e, "Crew Transfers");
                    }}
                  >
                    <i className="fas fa-car"></i>
                    <span>Crew Transfers</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    title="Crew Transfers"
                    className="nav-link"
                    href="/crew-activity"
                    onClick={(e) => {
                      this.menuClick(e, "Crew Activity");
                    }}
                  >
                    <i className="fas fa-user"></i>
                    <span>Crew Activity</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    title="Tracking"
                    className="nav-link"
                    href="/tracking"
                    onClick={(e) => {
                      this.menuClick(e, "Tracking");
                    }}
                  >
                    <i className="fas fa-globe-asia"></i>
                    <span>Tracking</span>
                  </a>
                </li>
                {/* <li className="nav-item">
                  <a
                    href="/"
                    className="nav-link has-dropdown"
                    title="Approvals"
                    data-toggle="dropdown"
                  >
                    <i className="fas fa-thumbs-up"></i>
                    <span>Approvals</span>
                  </a>
                  <ul className="dropdown-menu">
                    <li
                      className="nav-item"
                      style={{
                        display: this.state.userTypeId != 9 ? "block" : "none",
                      }}
                    >
                      <a
                        title="Scheduling Department"
                        className="nav-link"
                        href="/billing"
                        onClick={(e) => {
                          this.menuClick(e, "Scheduling Department");
                        }}
                      >
                        <i className="fas fa-thumbs-up"></i>
                        <span>Scheduling Department</span>
                      </a>
                    </li>
                  </ul>
                </li> */}
                {/* <li className="nav-item">
                  <a
                    href="/"
                    className="nav-link has-dropdown"
                    title="Masters"
                    data-toggle="dropdown"
                  >
                    <i className="fas fa-times"></i>
                    <span>No Show</span>
                  </a>
                  <ul className="dropdown-menu">
                    <li className="nav-item">
                      <a
                        title="Users"
                        className="nav-link"
                        href="/reimburseTransport"
                        onClick={(e) => {
                          this.menuClick(e, "Transportation Reimbursement");
                        }}
                      >
                        <i className="fas fa-rupee-sign"></i>
                        <span>Reimbursement</span>
                      </a>
                    </li>
                  </ul>
                </li> */}
                <li className="nav-item">
                  <a
                    href="/"
                    className="nav-link has-dropdown"
                    title="Masters"
                    data-toggle="dropdown"
                  >
                    <i className="fas fa-server"></i>
                    <span>Masters</span>
                  </a>
                  <ul className="dropdown-menu">
                    <li className="nav-item">
                      <a
                        title="Service Providers"
                        className="nav-link"
                        href="/service-providers"
                        onClick={(e) => {
                          this.menuClick(e, "Service Providers");
                        }}
                      >
                        <i className="fas fa-building"></i>
                        <span>Service Providers</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        title="Staff Members"
                        className="nav-link"
                        href="/crew-member"
                        onClick={(e) => {
                          this.menuClick(e, "Staff Members");
                        }}
                      >
                        <i className="fas fa-user-nurse"></i>
                        <span>Staff Members</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        title="Staff Address"
                        className="nav-link"
                        href="/crew-address"
                        onClick={(e) => {
                          this.menuClick(e, "Staff Address");
                        }}
                      >
                        <i className="fas fa-home"></i>
                        <span>Staff Address</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        title="Airport"
                        className="nav-link"
                        href="/airport"
                        onClick={(e) => {
                          this.menuClick(e, "Airport");
                        }}
                      >
                        <i className="fas fa-plane"></i>
                        <span>Airport</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        title="Crew Hotel"
                        className="nav-link"
                        href="/hotels"
                        onClick={(e) => {
                          this.menuClick(e, "Crew Hotel");
                        }}
                      >
                        <i className="fas fa-hotel"></i>
                        <span>Hotel</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        title="Users"
                        className="nav-link"
                        href="/user"
                        onClick={(e) => {
                          this.menuClick(e, "Users");
                        }}
                      >
                        <i className="fas fa-user-circle"></i>
                        <span>Users</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        title="Activity Code"
                        className="nav-link"
                        href="/activity-code"
                        onClick={(e) => {
                          this.menuClick(e, "Activity Code");
                        }}
                      >
                        <i className="fas fa-car-side"></i>
                        <span>Activity Code</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        title="Activity Location"
                        className="nav-link"
                        href="/nonfly-activity-location"
                        onClick={(e) => {
                          this.menuClick(e, "Activity Location");
                        }}
                      >
                        <i className="fas fa-street-view"></i>
                        <span>Activity Location</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        title="Transport Matrix"
                        className="nav-link"
                        href="/nonfly-transport-matrix"
                        onClick={(e) => {
                          this.menuClick(e, "Non Fly Transport Matrix");
                        }}
                      >
                        <i className="fas fa-car-side"></i>
                        <span>Non Fly Trans Matrix</span>
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="nav-item">
                  <a
                    href="/"
                    className="nav-link has-dropdown"
                    title="Configuration"
                    data-toggle="dropdown"
                  >
                    <i className="fas fa-server"></i>
                    <span>Configuration</span>
                  </a>
                  <ul className="dropdown-menu">
                    <li className="nav-item">
                      <a
                        title="Hotel Transfer Contract"
                        className="nav-link"
                        href="/config/hotel-transfer-contract"
                        onClick={(e) => {
                          this.menuClick(e, "Hotel Transfer Contract");
                        }}
                      >
                        <i className="fas fa-hotel"></i>
                        <span>Hotel Transfer Contract</span>
                      </a>
                    </li>
                    {/* <li className="nav-item">
                      <a
                        title="Hotel Transport Configuration"
                        className="nav-link"
                        href="/config/transporthotel"
                        onClick={(e) => {
                          this.menuClick(e, "Hotel Transport Configuration");
                        }}
                      >
                        <i className="fas fa-hotel"></i>
                        <span>Hotel Transport Configuration</span>
                      </a>
                    </li> */}
                    <li className="nav-item">
                      <a
                        title="Airport Transfer"
                        className="nav-link"
                        href="/config/airport-transfer"
                        onClick={(e) => {
                          this.menuClick(e, "Airport Transfer");
                        }}
                      >
                        <i className="fas fa-users"></i>
                        <span>Airport Transfer</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        title="Activity Duty Location Transfer"
                        className="nav-link"
                        href="/config/duty-location-transfer"
                        onClick={(e) => {
                          this.menuClick(e, "Activity Duty Location Transfer");
                        }}
                      >
                        <i className="fas fa-users"></i>
                        <span>Activity Duty Location Transfer</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        title="Airport Hotel Location Transport Matrix"
                        className="nav-link"
                        href="/config/transport-matrix"
                        onClick={(e) => {
                          this.menuClick(e, "Transport Matrix");
                        }}
                      >
                        <i className="fas fa-hotel"></i>
                        <span>Transport Matrix</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        title="Booking Hotel Priority"
                        className="nav-link"
                        href="/config/booking/hotelpriority"
                        onClick={(e) => {
                          this.menuClick(e, "Booking Hotel Priority");
                        }}
                      >
                        <i className="fas fa-users"></i>
                        <span>Booking Hotel Priority</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        title="Email Configuration"
                        className="nav-link"
                        href="/config/email"
                        onClick={(e) => {
                          this.menuClick(e, "Email Configuration");
                        }}
                      >
                        <i className="fas fa-envelope"></i>
                        <span>Email Configuration</span>
                      </a>
                    </li>
                  </ul>
                </li>
                {/* <li className="nav-item">
                  <a
                    title="Hotel Booking"
                    className="nav-link"
                    href="/hotelbooking"
                    onClick={(e) => {
                      this.menuClick(e, "Hotel Booking");
                    }}
                  >
                    <i className="fas fa-hotel"></i>
                    <span>Hotel Booking</span>
                  </a>
                </li> */}
                {/* <li className="nav-item">
                  <a
                    title="Invoice"
                    className="nav-link"
                    href="/invoice"
                    onClick={(e) => {
                      this.menuClick(e, "Invoice");
                    }}
                  >
                    <i className="fas fa-file-invoice"></i>
                    <span>Invoice</span>
                  </a>
                </li> */}
                <li className="nav-item">
                  <a
                    title="Message"
                    className="nav-link"
                    href="/notification"
                    onClick={(e) => {
                      this.menuClick(e, "Alerts & Notifications");
                    }}
                  >
                    <i className="fas fa-envelope-open-text"></i>
                    <span>Alerts & Notifications</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    title="Rating"
                    className="nav-link"
                    href="/rating"
                    onClick={(e) => {
                      this.menuClick(e, "Rating");
                    }}
                  >
                    <i className="fas fa-star"></i>
                    <span>Rating</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    title="Feedback"
                    className="nav-link"
                    href="/feedback"
                    onClick={(e) => {
                      this.menuClick(e, "Feedback");
                    }}
                  >
                    <i className="fas fa-comment-dots"></i>
                    <span>Feedback</span>
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    href="/"
                    className="nav-link has-dropdown"
                    title="Report"
                    data-toggle="dropdown"
                  >
                    <i className="fas fa-server"></i>
                    <span>Report</span>
                  </a>
                  <ul className="dropdown-menu">
                    <li className="nav-item">
                      <a
                        title="Cancel Hotel"
                        className="nav-link"
                        href="/report/cancel"
                        onClick={(e) => {
                          this.menuClick(e, "Cancel Hotel");
                        }}
                      >
                        <i className="fas fa-hotel"></i>
                        <span>Cancel Hotel</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        title="Stay Hotel"
                        className="nav-link"
                        href="/report/stay"
                        onClick={(e) => {
                          this.menuClick(e, "Stay Hotel");
                        }}
                      >
                        <i className="fas fa-hotel"></i>
                        <span>Stay Hotel</span>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        title="Airport Geofence Report"
                        className="nav-link"
                        href="/report/geofence"
                        onClick={(e) => {
                          this.menuClick(e, "Airport Geofence Report");
                        }}
                      >
                        <i className="fas fa-file-excel"></i>
                        <span>Airport Geofence Report</span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            ) : (
              <ul className="sidebar-menu">
                <li className="nav-item">
                  <a
                    title="Dashboard"
                    className="nav-link"
                    href="/dashboard"
                    onClick={(e) => {
                      this.menuClick(e, "Dashboard");
                    }}
                  >
                    <i className="fas fa-chalkboard"></i>
                    <span>Dashboard</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    title="Schedule Dashboard"
                    className="nav-link"
                    href="/scheduleDashboard"
                    onClick={(e) => {
                      this.menuClick(e, "Schedule Dashboard");
                    }}
                  >
                    <i className="fas fa-calendar-alt"></i>
                    <span>Schedule Dashboard</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    title="Crew Transfers"
                    className="nav-link"
                    href="/dispatch"
                    onClick={(e) => {
                      this.menuClick(e, "Crew Transfers");
                    }}
                  >
                    <i className="fas fa-car"></i>
                    <span>Crew Transfers</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    title="Crew Transfers"
                    className="nav-link"
                    href="/crew-activity"
                    onClick={(e) => {
                      this.menuClick(e, "Crew Activity");
                    }}
                  >
                    <i className="fas fa-user"></i>
                    <span>Crew Activity</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    title="Tracking"
                    className="nav-link"
                    href="/tracking"
                    onClick={(e) => {
                      this.menuClick(e, "Tracking");
                    }}
                  >
                    <i className="fas fa-globe-asia"></i>
                    <span>Tracking</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    title="Rating"
                    className="nav-link"
                    href="/rating"
                    onClick={(e) => {
                      this.menuClick(e, "Rating");
                    }}
                  >
                    <i className="fas fa-star"></i>
                    <span>Rating</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    title="Feedback"
                    className="nav-link"
                    href="/feedback"
                    onClick={(e) => {
                      this.menuClick(e, "Feedback");
                    }}
                  >
                    <i className="fas fa-comment-dots"></i>
                    <span>Feedback</span>
                  </a>
                </li>
              </ul>
            )}
            <div style={{ marginTop: "auto" }}>
              <div className="sidebar-powered-by">
                <span>Powered by</span>
                <a href="http://www.plexitech.com/" style={{ lineHeight: 1 }}>
                  <img
                    src="../assets/img/logo-plexitech2.png"
                    alt="PlexiTech"
                  />
                </a>
              </div>
            </div>
          </aside>
        </div>
      </Fragment>
    );
  }
}
